import { Button, Grid, Layout, Paper, Table, Loader, ButtonGroup, Menu, Typography } from "../../components";
import moment from "moment";
import { useAxios } from '../../hooks'
import { Fragment } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Chip } from "@mui/material";
import { getSupportTicketStatusColor, getSupportTicketStatusLabel } from "../../utils";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useNavigate } from "react-router-dom";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export function Help () {
    const navigate = useNavigate()
    const [tickets] = useAxios(`/support-ticket`)
    
    return (
        <Layout>
            <Grid container justifyContent="center" padding={3} spacing={2}>
                {tickets.loading ? (
                    <div style={{
                        display: 'flex',
                        flex: '1',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <Loader />
                    </div>
                ) : (
                    <Fragment>
                    <Grid item xs={12} sm={10} textAlign="left">
                    <Accordion>
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                        >
                        <Typography component="span" fontWeight="bold">
                        FAQ - DÚVIDAS FREQUENTES(se não encontrar aqui sua dúvida, entre em contato conosco pelos canais oficiais)</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <ul style={{
                                listStylePosition: 'inside',
                                listStyleType: 'decimal',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 10
                            }}>
                                <li>
                                    <strong>Como faço uma oferta?</strong>
                                    <p>No MENU à esquerda acesse MINHAS OFERTAS e clique em NOVA OFERTA. Escolha o PROGRAMA que quer vender as milhas, ADICIONE (+) ou escolha uma conta e prossiga. Em seguida escolha a QUANTIDADE de milhas, VALOR do milheiro e NÚMERO de cpfs (emissões), e finalize sua oferta.</p>
                                </li>
                                <li>
                                    <strong>O que coloco no campo SENHA que aparece quando adiciono uma nova conta/oferta?</strong>
                                    <p>Nesse campo você deverá preencher a SENHA DO PROGRAMA (Smiles, LATAM, TAP,…) que está fazendo a oferta.</p>
                                </li>
                                <li>
                                    <strong>O que seriam os “CPFs”?</strong>
                                    <p>CPFs é como tratamos o número de passageiros em uma emissão. 1 CPF = 1 passageiro, 2 CPFs = 2 passageiros. Alguns programas possuem limitação de passageiros, e, por conta disso, nesse campo, você poderá estipular essa quantidade.</p>
                                    <p>LATAM: 25 passageiros a cada 12 meses</p>
                                    <p>SMILES: 25 passageiros por ano (de 01/01 até 31/12)</p>
                                    <p>TAP: 10 passageiros por ano (de 01/01 até 31/12)</p>
                                </li>
                                <li>
                                    <strong>Por que preciso fazer o redirecionamento do meu e-mail?</strong>
                                    <p>Para termos o acesso à conta e/ou realizarmos emissões, em alguns programas, há necessidade do envio de um código. E, como realizamos esses processos em diversos horários, precisamos que esses códigos sejam encaminhados à nós.</p>
                                </li>
                                <li>
                                    <strong>Quero alterar os dados de uma conta já cadastrada, como faço?</strong>
                                    <p>No MENU à esquerda acesse MINHAS CONTAS e, ao final da linha da conta, clique nos 3 PONTINHOS e em VER DETALHES. Altere os dados necessários e SALVE.</p>
                                </li>

                                <li>
                                    <strong>Quanto tempo se leva para utilizar minhas milhas?</strong>
                                    <p>As emissões são realizadas conforme demanda, então não há prazo definido para que sejam efetuadas.</p>
                                </li>

                                <li>
                                    <strong>Em qual prazo receberei pela venda?</strong>
                                    <p>Os pagamentos são realizados em 2 dias úteis após cada emissão finalizada.</p>
                                </li>

                                <li>
                                    <strong>Como faço para verificar meus pagamentos pendentes?</strong>
                                    <p>No MENU à esquerda acesse MEUS PAGAMENTOS. Lá encontrará todas as informações sobre as emissões, valores e datas de pagamento.</p>
                                </li>

                                <li>
                                    <strong>Como faço caso eu decida por cancelar minha oferta?</strong>
                                    <p>Caso decida por cancelar a venda, é só entrar em contato conosco pelo nosso suporte aqui no site ou número de WhatsApp para solicitar a finalização dela.</p>
                                </li>

                                <li>
                                    <strong>Caso haja um cancelamento em minha conta e as milhas retornem para meu saldo, o que devo fazer?</strong>
                                    <p>Quando ocorre um cancelamento e as milhas retornam para seu saldo no programa, nós iremos reutilizá-las em outra emissão. Caso decida por utilizá-las, terá que nos reembolsar do valor já pago.</p>
                                </li>

                            </ul>
                        </AccordionDetails>
                    </Accordion>
                    </Grid>
                        <Grid item xs={12} sm={10} textAlign="right">
                            <Button href="/ajuda/novo">
                                Abrir Chamado
                            </Button>
                        </Grid>
                <Grid item xs={12} sm={10}>
                    <Paper elevation={1}>
                    <Table 
                        columns={[
                            { field: 'id', headerName: 'ID', width: 100 },
                            { field: 'created_at', headerName: 'Data', width: 200, valueFormatter: ({value}) => {
                                return moment(value).format('DD/MM/YYYY HH:mm:ss')
                            } },
                            { field: 'bid_id', headerName: 'ID da Oferta', width: 200 },
                            { field: 'message', headerName: 'Mensagem', flex: 2, valueGetter: ({row}) => row.support_ticket_messages[0].message },
                            {
                                field: 'status', headerName: 'Status', flex: 1, 
                                valueGetter: ({value}) => {
                                    return getSupportTicketStatusLabel(value)
                                },
                                renderCell: ({ formattedValue, row }) => {
                                    return (
                                        <Chip color={getSupportTicketStatusColor(row.status)} label={formattedValue} />
                                    )
                                }
                            },
                            {
                                field: 'actions', headerName: '', sortable: false, filterable: false, disableColumnMenu: true, renderCell: ({row}) => {
                                    return (
                                        <ButtonGroup>
                                            <Menu
                                                options={[
                                                    {
                                                        label: 'Ver Detalhes', 
                                                        onClick: async () => {
                                                            navigate(`/ajuda/${row.id}`)
                                                        }
                                                    }
                                                ]}
                                            >
                                                <MoreHorizIcon />
                                            </Menu>
                                        </ButtonGroup>
                                    )
                                }
                            }
                        ]}
                        rows={(tickets?.data || [])}
                    />
                    </Paper>
                </Grid>
                </Fragment>)}
            </Grid>
        </Layout>
    )
}